import React from 'react';
import { FormShell } from '../../../../../../generic/ui/FormLayout';
import { AccentButton } from '../../../../../../generic/ui/Button';

interface Props {
    onPrint: () => void;
    onFinish: () => void;
    closeFunc?: (flag?: boolean) => void;
}

const ModalTeudaCreated: React.FC<Props> = ({ onPrint, onFinish }) => (
    <FormShell>
        <AccentButton type='button' onClick={onPrint}>
            להדפיס ולסיים
        </AccentButton>
        <AccentButton type='button' variant='ghost' onClick={onFinish}>
            סיים
        </AccentButton>
    </FormShell>
);

export default ModalTeudaCreated;
